import { NavLink } from "react-router-dom";
import logo from "../assets/img/logo.svg";

export const Footer = () => {
  return (
    <>
      <div className="h-3 w-full bg-primary"></div>
      <div className="bg-[#E4DFDC] py-9 px-4 text-center text-[#727272]">
        <div className="flex flex-col md:flex-row justify-center items-start md:items-center max-w-96 md:max-w-[1260px] mx-auto gap-x-16 gap-y-6 pb-9">
          <div className="w-auto md:w-1/3"><img src={logo} /></div>
          <div className="">
            {/* <div className="text-center leading-[30px] shrink-0">
              <NavLink to="/unit">
                <div>單位介紹</div>
              </NavLink>
              <NavLink to="/plan">
                <div>計劃專區</div>
              </NavLink>
              <div>常見問題</div>
              <div>資通安全及隱私政策</div>
            </div>
            <div className="text-center leading-[30px] shrink-0">
              <NavLink to="/info">
                <div>研習資訊</div>
              </NavLink>
              <NavLink to="/main">
                <div>教學資源</div>
              </NavLink>
              <NavLink to="/repair">
                <div>線上報修</div>
              </NavLink>
              <NavLink to="/procurement">
                <div>軟體採購</div>
              </NavLink>
            </div> */}
            <div className="flex flex-col gap-2 text-left">
              <div className="font-semibold">聯絡我們</div>
              <div className="flex items-center gap-2"><img src="/images/tel.svg" alt="" className="w-[14px]" />07-7260089</div>
              <a href="https://lin.ee/HsO5eQB" target="_blank" rel="noreferrer noopener" className="flex items-center gap-2 hover:underline">
                <img src="/images/line.svg" alt="" className="w-4" />加入LINE</a>
              <div className="flex items-center gap-2"><img src="/images/clock.svg" alt="" className="w-4" />週一至週五 08:00～17:00</div>
              <a href="https://maps.app.goo.gl/WwtHjPxhMKEzisAs9?g_st=il" target='_blank' rel="noreferrer noopener" className="mapa break-keep -indent-6 hover:text-gray-600 hover:underline ml-6">
                830023高雄市鳳山區鳳松路25巷20號 (夢想樓2樓)</a>
            </div>
          </div>
        </div>
        <hr className="border-[#72727266] mx-auto" />
        <div className="flex flex-col md:flex-row justify-center md:justify-between max-w-7xl mt-9 mx-auto gap-4">
          <div className="order-3 md:order-1">Copyright © 2024 高雄市政府教育局 All right reserved</div>
          <a href="/sitemap" className="order-1 md:order-2 font-semibold hover:underline">網站導覽</a> 
          <a href="/privacy-policy" className="order-2 md:order-3 font-semibold hover:underline">隱私權及安全政策</a> 
        </div>
      </div>
    </>
  )

}